"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var section_1 = __importDefault(require("./components/field-templates/section"));
var text_1 = __importDefault(require("./components/field-templates/text"));
var file_upload_1 = __importDefault(require("./components/field-templates/file-upload"));
var single_line_text_1 = __importDefault(require("./components/field-templates/single-line-text"));
var button_1 = __importDefault(require("./components/field-templates/button"));
var checkbox_1 = __importDefault(require("./components/field-templates/checkbox"));
var checkbox_list_1 = __importDefault(require("./components/field-templates/checkbox-list"));
var dropdown_list_1 = __importDefault(require("./components/field-templates/dropdown-list"));
var date_1 = __importDefault(require("./components/field-templates/date"));
var email_1 = __importDefault(require("./components/field-templates/email"));
var list_box_1 = __importDefault(require("./components/field-templates/list-box"));
var multiple_line_text_1 = __importDefault(require("./components/field-templates/multiple-line-text"));
var number_1 = __importDefault(require("./components/field-templates/number"));
var password_1 = __importDefault(require("./components/field-templates/password"));
var radio_button_list_1 = __importDefault(require("./components/field-templates/radio-button-list"));
var telephone_1 = __importDefault(require("./components/field-templates/telephone"));
var FieldTypes_1 = require("./FieldTypes");
var field_factory_1 = __importDefault(require("./field-factory"));
function createDefaultFieldFactory() {
  var defaultFieldFactory = new field_factory_1.default();
  defaultFieldFactory.setComponent(FieldTypes_1.FieldTypes.Section, section_1.default);
  defaultFieldFactory.setComponent(FieldTypes_1.FieldTypes.TextField, text_1.default);
  defaultFieldFactory.setComponent(FieldTypes_1.FieldTypes.Button, button_1.default);
  defaultFieldFactory.setComponent(FieldTypes_1.FieldTypes.SingleLineText, single_line_text_1.default);
  defaultFieldFactory.setComponent(FieldTypes_1.FieldTypes.MultipleLineText, multiple_line_text_1.default);
  defaultFieldFactory.setComponent(FieldTypes_1.FieldTypes.DateField, date_1.default);
  defaultFieldFactory.setComponent(FieldTypes_1.FieldTypes.Email, email_1.default);
  defaultFieldFactory.setComponent(FieldTypes_1.FieldTypes.NumberField, number_1.default);
  defaultFieldFactory.setComponent(FieldTypes_1.FieldTypes.Checkbox, checkbox_1.default);
  defaultFieldFactory.setComponent(FieldTypes_1.FieldTypes.Telephone, telephone_1.default);
  defaultFieldFactory.setComponent(FieldTypes_1.FieldTypes.FileUpload, file_upload_1.default);
  defaultFieldFactory.setComponent(FieldTypes_1.FieldTypes.DropdownList, dropdown_list_1.default);
  defaultFieldFactory.setComponent(FieldTypes_1.FieldTypes.CheckboxList, checkbox_list_1.default);
  defaultFieldFactory.setComponent(FieldTypes_1.FieldTypes.ListBox, list_box_1.default);
  defaultFieldFactory.setComponent(FieldTypes_1.FieldTypes.RadioButtonList, radio_button_list_1.default);
  defaultFieldFactory.setComponent(FieldTypes_1.FieldTypes.Password, password_1.default);
  return defaultFieldFactory;
}
exports.createDefaultFieldFactory = createDefaultFieldFactory;
exports.default = createDefaultFieldFactory();